'use client'

import { useFeatureFlag } from '../../app/_providers/ExperimentationProvider.client'

export function usePrimaryNavNestedMenuExperiment() {
  const decision = useFeatureFlag<'true' | 'false'>({
    key: 'nested-nav-test',
    controlVariant: 'false',
    ifAccessedPriorToDecisionInitialization: 'return-null-while-pending',
  })

  return {
    isNestedMenuVariant: decision === 'true',
  }
}
